import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsIATALoading = (state) => state.listing.MRD_ADMINISTRATION_IATA.isLoading;
export const getIATAData = TableDefinitions.MRD_ADMINISTRATION_IATA.getDataFunction();
export const getIsFlightsLoading = (state) => state.listing.MRD_ADMINISTRATION_FLIGHTS?.isLoading;
export const getFlightData = TableDefinitions.MRD_ADMINISTRATION_FLIGHTS?.getDataFunction();

export const getAllIataCodes = (state) => state.flight.allIataCodes;
export const getLastRequestStatus = (state) => state.flight.lastRequestStatus;
export const getSelectedIATA = (state) => state.flight.selectedIATACode;
export const getCheckboxStatus = (state) => state.flight.showManualEntrySelection;
export const getSortedIataCodes = (state) => state.flight.sortedIataCodes;
export const getSelectedManualFlight = (state) => state.flight.selectedManualFlight;
export const getIsManualFlightLoading = (state) => state.flight.manualFlightLoading;
